export default [
  {
    title: 'Tags',
    icon: 'mdi-tag-multiple',
    to: 'TagsAttributes',
    keywords: ['แท็ก', 'ป้ายกำกับ', 'tag']
  },
  {
    title: 'Collection',
    icon: 'mdi-rhombus-split',
    to: 'CollectionAttribute',
    keywords: ['คอลเลกชัน', 'ชุดสินค้า', 'collection']
  },
  {
    title: 'Group Category',
    icon: 'mdi-gamepad-circle-outline',
    to: 'GroupCategoryAttribute',
    keywords: ['กลุ่มหมวดหมู่', 'group', 'category']
  },
  {
    title: 'Color',
    icon: 'mdi-palette',
    to: 'ColorAttributes',
    keywords: ['สี', 'color']
  },
  {
    title: 'Category',
    icon: 'mdi-tshirt-crew',
    to: 'CategoryAttributes',
    keywords: ['หมวดหมู่', 'ประเภทสินค้า', 'category']
  },
  {
    title: 'Brand',
    icon: 'mdi-storefront',
    to: 'BrandAttributes',
    keywords: ['แบรนด์', 'ยี่ห้อ', 'brand']
  },
  {
    title: 'Size',
    icon: 'mdi-size-xl',
    to: 'SizeAttributes',
    keywords: ['ไซส์', 'ขนาด', 'size']
  },
  {
    title: 'MixAndMatch',
    icon: 'mdi-cash-multiple',
    to: 'MixAndMacthAttributes',
    keywords: ['มิกซ์แอนด์แมตช์', 'จับคู่ราคา', 'mix', 'match']
  },
  {
    title: 'ForeignCurrency',
    icon: 'mdi-cash-multiple',
    to: 'ForeignCurrencyAttributes',
    keywords: ['สกุลเงินต่างประเทศ', 'เงินตรา', 'foreign', 'currency']
  },
  {
    title: 'Sale Tags',
    icon: 'mdi-tag-multiple',
    to: 'SaleTags',
    keywords: ['แท็กลดราคา', 'ป้ายเซล', 'sale', 'tag']
  }
]
